module.exports = __webpack_public_path__ + "img/executor.37374e02.svg";